import React from 'react';
import VisaStatus from '../components/VisaStatusPageBody';

function VisaStatusPage() {
    return <VisaStatus />;
}

export default VisaStatusPage;